import { actionQueryFields, actionFieldDefaultsQuery } from "./reducers/actions"
import { queryQueryFields } from "./reducers/queries"
import { appletQueryFields } from "./reducers/applet"
import { serviceQueryFields } from "./reducers/services"
import { triggerQueryFields } from "./reducers/triggers"
import { graphQueryBang as query } from "../../../shared/lib/graphql"

export function loadApplet(appletId) {
  return query(`query {
    applet(id: ${escape(appletId)}) { ${appletQueryFields} }
  }`).then(data => data.applet)
}

export function loadServices(moduleNames) {
  return query(`query {
    channels(module_names: ${JSON.stringify(
      moduleNames
    )}) { ${serviceQueryFields} }
  }`).then(data => data.channels)
}

export function loadTriggers(serviceModuleName) {
  return query(`query {
    channel(module_name: ${escape(serviceModuleName)}) {
      triggers { ${triggerQueryFields} }
    }
  }`).then(data => data.channel.triggers)
}

export function loadQueries(serviceModuleName) {
  return query(`query {
    channel(module_name: ${escape(serviceModuleName)}) {
      queries {
        ${queryQueryFields}
      }
    }
  }`).then(data => data.channel.queries)
}

export function loadActions(serviceModuleName, currentTriggerId) {
  const defaultsQuery = currentTriggerId
    ? actionFieldDefaultsQuery(currentTriggerId)
    : ""

  return query(`query {
    channel(module_name: ${escape(serviceModuleName)}) {
      actions {
        ${actionQueryFields}
        ${defaultsQuery}
      }
    }
  }`).then(data => data.channel.actions)
}

export function loadTandas(triggerModuleName, actionModuleName) {
  const defaultsQuery = triggerModuleName
    ? actionFieldDefaultsQuery(triggerModuleName)
    : ""

  return query(`query {
    trigger(module_name: "${triggerModuleName}") {
      ${triggerQueryFields}
    }
    action(module_name: "${actionModuleName}") {
      ${actionQueryFields}
      ${defaultsQuery}
    }
  }`).then(data => {
    return {
      trigger: data.trigger,
      action: data.action,
    }
  })
}

export function createOrUpdateApplet(payload, id, updateURL) {
  return new Promise((resolve, reject) => {
    const url = `${updateURL}${id ? `/${id}` : ""}`
    window.$.ajax(url, {
      type: id ? "PUT" : "POST",
      data: JSON.stringify({
        applet: payload,
        authenticity_token: window.App.authenticityToken,
      }),
      contentType: "application/json",
    })
      .done(resolve)
      .fail(err => reject(err.responseJSON))
  })
}

function escape(id) {
  return JSON.stringify(id.toString())
}
